import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const TZMO_SITE = process.env.REACT_APP_LANG ? process.env.REACT_APP_LANG.toUpperCase() : '';
const defaultTitle = `TZMO ${TZMO_SITE} Extranet`;

const Page = forwardRef(({ children, title = '', ...other }, ref) => {
  const fullTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;
  return (
    <Box ref={ref} {...other}>
      <Helmet>
        <title>{fullTitle}</title>
      </Helmet>
      {children}
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
